import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import baseLoginValidator from 'utils/validators/baseLoginValidator'
import emailValidator from 'utils/validators/emailValidator'
import * as Yup from 'yup'
import LoginField from '../subcomponents/LoginField'
import { useAccountCreateFormSubmit } from 'modules/Forms/Account/Create/useAccountCreateFormSubmit'
import SubmitButtons from 'modules/Forms/Account/Create/subcomponents/submitButtons'

export const AdgramSchema = () =>
  Yup.object().shape({
    logins: Yup.array().of(Yup.object()),
    login: Yup.string().when('logins', ([logins], schema) =>
      logins
        ? schema.strip()
        : schema
            .test('baseLoginTest', '', baseLoginValidator)
            .required('common::validation_messages.required'),
    ),
    network: Yup.string().required('common::validation_messages.required'),
    email: Yup.string()
      .test('emailValidator', 'common::validation_messages.incorrect_email_format', emailValidator)
      .required('common::validation_messages.required'),
    lastname: Yup.string().required('common::validation_messages.required'),
    firstname: Yup.string().required('common::validation_messages.required'),
  })

let CreateAdgramAccountForm = ({
  handleSubmit,
  submitting,
  onClose,
  autofill,
  formHeader,
  networkId,
  form,
  initialValues,
  array,
  multiLogins,
}) => {
  const selector = formValueSelector(form)

  const { t } = useTranslation()
  const submitAccountData = useAccountCreateFormSubmit(form, onClose, multiLogins)

  const { email, user } = useSelector((state) => ({
    email: selector(state, 'email'),
    user: state['app'].user,
  }))

  useEffect(() => {
    user.name && email === initialValues.email && autofill('email', user.name)
  }, [user])

  return (
    <>
      {formHeader}

      <form
        onSubmit={handleSubmit(submitAccountData)}
        noValidate
      >
        <Field
          disabled
          name="network"
          hidden
          fullWidth
          component={renderInputField}
          t={t}
        />

        <div className={'margin-bottom-16'}>
          <LoginField
            autofill={autofill}
            networkId={networkId}
            form={form}
            multiLogins={multiLogins}
            array={array}
            label={'services::forms.register_account.adgram.fields.login.label'}
          />
        </div>

        <div className={'margin-bottom-16'}>
          <Field
            name="email"
            type="email"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.adgram.fields.email.label')}
            t={t}
          />
        </div>

        <div className={'margin-bottom-16'}>
          <Field
            name="firstname"
            type="text"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.adgram.fields.firstname.label')}
            t={t}
          />
        </div>

        <div className={'margin-bottom-16'}>
          <Field
            name="lastname"
            type="text"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.adgram.fields.lastname.label')}
            t={t}
          />
        </div>

        <SubmitButtons
          submitting={submitting}
          onClose={onClose}
        />
      </form>
    </>
  )
}

CreateAdgramAccountForm = reduxForm({
  form: 'CreateAdgramAccountForm',
  initialValues: {
    login: '',
    network: '',
    email: '',
    lastname: '',
    firstname: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
})(CreateAdgramAccountForm)

CreateAdgramAccountForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  autofill: PropTypes.func,
  networkId: PropTypes.string,
  networkType: PropTypes.string,
  initialValues: PropTypes.object,
  form: PropTypes.string,
  multiLogins: PropTypes.bool,
  array: PropTypes.object,
  formHeader: PropTypes.node,
}

export default CreateAdgramAccountForm
